import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { XIcon } from "./icons";

/**
 * Right-side drawer (§2.7), 480px: for reference-heavy or long content
 * (policy detail, prefilled edit forms). Esc and overlay-click close.
 */
function Drawer({ open, onClose, title, footer, children }) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if (panelRef.current) {
      panelRef.current.focus();
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className="fk-overlay fk-overlay--drawer"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className="fk-drawer"
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === "string" ? title : undefined}
        tabIndex={-1}
        ref={panelRef}
      >
        <header className="fk-drawer__header">
          <h2 className="fk-drawer__title">{title}</h2>
          <button type="button" className="fk-icon-btn" onClick={onClose} aria-label="Close">
            <XIcon />
          </button>
        </header>
        <div className="fk-drawer__body">{children}</div>
        {footer ? <footer className="fk-drawer__footer">{footer}</footer> : null}
      </div>
    </div>,
    document.body
  );
}

export default Drawer;
